import { inject } from "fw";
import { Manager } from "./manager";
import { wait } from "wait";
import { CommonAppIntegration, CommonAppIntegrationArgs, CommonAppMappingException } from "models/common-app-integration";

@inject
export class CommonAppIntegrationRepository {
    constructor(private s: Manager) {}

    async post(atsOrganizationId: string, integration: CommonAppIntegrationArgs) {
        const data = new FormData();
        data.append("CommonAppYear", integration.CommonAppYear + "");
        data.append("SdsUsername", integration.SdsUsername);
        data.append("SdsPassword", integration.SdsPassword);
        data.append("DataCatalog", integration.DataCatalog);
        data.append("Enabled", integration.Enabled ? "true" : "false");

        const res = await this.s.post<CommonAppIntegration>("common-app-integration", data, { atsOrganizationId });
        await wait(1000);
        return res.body;
    }

    async put(commonAppIntegrationId: string, integration: CommonAppIntegrationArgs) {
        const data = new FormData();
        data.append("CommonAppYear", integration.CommonAppYear + "");
        data.append("SdsUsername", integration.SdsUsername);
        if (integration.SdsPassword) data.append("SdsPassword", integration.SdsPassword);
        if (integration.DataCatalog) data.append("DataCatalog", integration.DataCatalog);
        data.append("Enabled", integration.Enabled ? "true" : "false");

        const res = await this.s.put<CommonAppIntegration>(`common-app-integration/${commonAppIntegrationId}`, data);
        await wait(1000);
        return res.body;
    }

    async delete(id: string) {
        const res = await this.s.delete(`common-app-integration/${id}`);
        await wait(1000); // waiting here for backend write commit to complete in ES
    }

    async get(id: string) {
        const res = await this.s.get<CommonAppIntegration>(`common-app-integration/${id}`);
        await wait(1000);
        return res.body;
    }

    async mappingWarnings(id: string) {
        const res = await this.s.get<CommonAppMappingException[]>(`common-app-integration/${id}/mapping-exceptions`);
        return res.body;
    }

    async run(atsOrganizationId: string, forceRefresh: boolean) {
        await this.s.post(`common-app-integration/run/${atsOrganizationId}?forceRefresh=${forceRefresh}`, null);
    }

    async validateSdsCredentials(commonAppIntegrationId: string) {
        const res = await this.s.post<{ Status: boolean; Message: string }>(`common-app-integration/ValidateSdsCredentials/${commonAppIntegrationId}`, null);
        return res.body;
    }
}
